/* ============================
   RIFTED — PRODUCT PAGE JS
   ============================ */

(function() {

  const variants = window.productData ? window.productData.variants : [];
  let currentImageIndex = 0;
  let selectedOptions = {};

  // ============================
  // GALLERY
  // ============================
  window.switchImage = function(index) {
    const imgs = document.querySelectorAll('.product-main-img');
    const thumbs = document.querySelectorAll('.product-thumb');
    const dots = document.querySelectorAll('.gallery-dot');

    imgs.forEach(i => i.classList.remove('active'));
    thumbs.forEach(t => t.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));

    const target = document.querySelector(`.product-main-img[data-index="${index}"]`);
    const targetThumb = document.querySelector(`.product-thumb[data-index="${index}"]`);
    const targetDot = dots[index];

    if (target) target.classList.add('active');
    if (targetThumb) { targetThumb.classList.add('active'); targetThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    if (targetDot) targetDot.classList.add('active');

    currentImageIndex = index;
  };

  window.prevImage = function() {
    const total = document.querySelectorAll('.product-main-img').length;
    switchImage((currentImageIndex - 1 + total) % total);
  };

  window.nextImage = function() {
    const total = document.querySelectorAll('.product-main-img').length;
    switchImage((currentImageIndex + 1) % total);
  };

  // Keyboard navigation
  document.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') prevImage();
    if (e.key === 'ArrowRight') nextImage();
  });

  // Touch/swipe support
  let touchStartX = 0;
  const wrap = document.querySelector('.product-main-img-wrap');
  if (wrap) {
    wrap.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) diff > 0 ? nextImage() : prevImage();
    });
  }

  // ============================
  // VARIANT SELECTION
  // ============================
  const variantBtns = document.querySelectorAll('.variant-btn');

  // Initialise selected options from first available variant
  if (variants.length > 0) {
    const first = variants.find(v => v.available) || variants[0];
    if (first.option1) selectedOptions[0] = first.option1;
    if (first.option2) selectedOptions[1] = first.option2;
    if (first.option3) selectedOptions[2] = first.option3;
  }

  variantBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const optionIndex = parseInt(this.getAttribute('data-option-index'));
      const value = this.getAttribute('data-value');

      // Update selected
      selectedOptions[optionIndex] = value;

      // Update active state per option group
      document.querySelectorAll(`.variant-btn[data-option-index="${optionIndex}"]`).forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // Find matching variant
      updateVariant();
    });
  });

  function updateVariant() {
    const matchedVariant = variants.find(v => {
      const o1 = selectedOptions[0] ? v.option1 === selectedOptions[0] : true;
      const o2 = selectedOptions[1] ? v.option2 === selectedOptions[1] : true;
      const o3 = selectedOptions[2] ? v.option3 === selectedOptions[2] : true;
      return o1 && o2 && o3;
    });

    if (!matchedVariant) return;

    // Update hidden input
    const variantInput = document.getElementById('variant-id');
    if (variantInput) variantInput.value = matchedVariant.id;

    // Update price
    const priceBlock = document.getElementById('price-block');
    const atcPrice = document.getElementById('atc-price');
    if (priceBlock) {
      const price = matchedVariant.price;
      const comparePrice = matchedVariant.compare_at_price;
      const formatted = formatMoney(price);
      const formattedCompare = formatMoney(comparePrice);

      if (comparePrice && comparePrice > price) {
        priceBlock.innerHTML = `<span class="product-price-compare">${formattedCompare}</span><span class="product-price-current sale">${formatted}</span>`;
      } else {
        priceBlock.innerHTML = `<span class="product-price-current">${formatted}</span>`;
      }
      if (atcPrice) atcPrice.textContent = `— ${formatted}`;
    }

    // Update availability
    const avail = document.getElementById('product-availability');
    const atcBtn = document.getElementById('add-to-cart');
    const atcText = document.getElementById('atc-text');
    if (avail) {
      if (matchedVariant.available) {
        avail.innerHTML = '<span class="avail-dot avail-dot--in"></span><span class="avail-text">In stock — Ships within 10 business days</span>';
        if (atcBtn) { atcBtn.disabled = false; atcBtn.classList.remove('btn-atc--sold'); }
        if (atcText) atcText.textContent = 'ADD TO CART';
      } else {
        avail.innerHTML = '<span class="avail-dot avail-dot--out"></span><span class="avail-text">Out of stock</span>';
        if (atcBtn) { atcBtn.disabled = true; atcBtn.classList.add('btn-atc--sold'); }
        if (atcText) atcText.textContent = 'SOLD OUT';
      }
    }

    // Update SKU
    const skuEl = document.getElementById('product-sku');
    if (skuEl && matchedVariant.sku) skuEl.textContent = matchedVariant.sku;

    // Update URL without page reload
    if (history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.set('variant', matchedVariant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  function formatMoney(cents) {
    if (!cents) return '$0.00';
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ============================
  // QUANTITY
  // ============================
  window.changeQty = function(delta) {
    const input = document.getElementById('quantity');
    if (!input) return;
    const current = parseInt(input.value) || 1;
    const next = Math.max(1, Math.min(99, current + delta));
    input.value = next;
  };

  // ============================
  // ADD TO CART
  // ============================
  const productForm = document.getElementById('product-form');
  const atcBtn = document.getElementById('add-to-cart');
  const atcText = document.getElementById('atc-text');

  if (productForm && atcBtn) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();

      const variantId = document.getElementById('variant-id')?.value;
      const quantity = parseInt(document.getElementById('quantity')?.value) || 1;

      if (!variantId) return;

      atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'ADDING...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });

        if (res.ok) {
          if (atcText) atcText.textContent = '✓ ADDED TO CART';
          atcBtn.style.background = '#2C6FD1';
          atcBtn.style.borderColor = '#2C6FD1';
          atcBtn.style.color = '#fff';

          // Update cart count
          const cartData = await (await fetch('/cart.js')).json();
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) {
            cartCount.textContent = cartData.item_count;
            cartCount.style.background = '#2C6FD1';
            setTimeout(() => cartCount.style.background = '', 800);
          }

          setTimeout(() => {
            if (atcText) atcText.textContent = 'ADD TO CART';
            atcBtn.style.background = '';
            atcBtn.style.borderColor = '';
            atcBtn.style.color = '';
            atcBtn.disabled = false;
          }, 2400);
        } else {
          const err = await res.json();
          if (atcText) atcText.textContent = err.description || 'SOLD OUT';
          setTimeout(() => {
            if (atcText) atcText.textContent = 'ADD TO CART';
            atcBtn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        if (atcText) atcText.textContent = 'TRY AGAIN';
        atcBtn.disabled = false;
      }
    });
  }

  // ============================
  // ACCORDIONS
  // ============================
  window.toggleAccordion = function(trigger) {
    const accordion = trigger.closest('.accordion');
    const isOpen = accordion.classList.contains('open');
    document.querySelectorAll('.accordion.open').forEach(a => a.classList.remove('open'));
    if (!isOpen) accordion.classList.add('open');
  };

})();
